import React, { useState } from 'react';
import styled from 'styled-components';

import { useFundingPaymentsPaginatedQuery } from '#/api/queries/fundingPaymentsQueries';
import MetaTags from '#/components/layout/header/MetaTags';
import { MarketSearchDropdown } from '#/components/markets/MarketSearchDropdown';
import WalletDashboardContent from '#/components/wallet/dashboard/WalletDashboardContent';
import { useSelector } from '#/reduxState/store';

import DownloadFundingCSV from './DownloadFundingCSV';
import FundingHistoryTable from './FundingHistoryTable';

const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

function FundingHistoryPage() {
  const isMobile = useSelector(state => state.screen.isMobile);
  const [page, setPage] = useState(1);
  const [searchMarket, setSearchMarket] = useState('');
  const walletAddress = useSelector(state => state.wallet.walletAddress);

  const {
    data: fundingPaymentsPaginated,
    isLoading,
    isPlaceholderData: isPreviousData,
  } = useFundingPaymentsPaginatedQuery({
    walletAddress,
    isVault: false,
    page,
    filterMarket: searchMarket || undefined,
  });

  const controlsDisabled = !fundingPaymentsPaginated?.count && !searchMarket;

  return (
    <>
      <MetaTags title="Funding History" />

      <WalletDashboardContent
        title="Funding History"
        showBalanceActions
        headerContentRight={
          isMobile ? (
            <DownloadFundingCSV disabled={controlsDisabled} />
          ) : (
            <Flex>
              <div style={{ padding: '0 16px 0 12px' }}>
                <DownloadFundingCSV disabled={controlsDisabled} />
              </div>
              <MarketSearchDropdown
                selectedMarket={searchMarket}
                onSelect={setSearchMarket}
                disabled={controlsDisabled}
              />
            </Flex>
          )
        }
        headerContentMiddle={
          isMobile ? (
            <div style={{ padding: '0 0 12px 0' }}>
              <MarketSearchDropdown
                selectedMarket={searchMarket}
                onSelect={setSearchMarket}
                disabled={controlsDisabled}
              />
            </div>
          ) : undefined
        }
      >
        <FundingHistoryTable
          walletAddress={walletAddress}
          isLoading={isLoading}
          onSetPage={setPage}
          page={page}
          showingPreviousPage={isPreviousData}
          pageItems={fundingPaymentsPaginated?.items}
          totalCount={fundingPaymentsPaginated?.count}
        />
      </WalletDashboardContent>
    </>
  );
}

export default FundingHistoryPage;
